<template>
   <!--  已实现盈利交易占比 -->
 <div v-loading="profitRateLoading" style="width: 100%; min-height: 700px">

      <!-- 公式 -->
      <el-row type="flex" justify="center">
        <div class="formulaBox1">
      <div>Percent UTXOs in Profit = 100· </div>
      <div>
        <p> UTXOs in Profit</p>
        <p> Number of UTXOs</p>
      </div>
     </div>

   </el-row>
   <Dropdown
          :dataSelection="dataSelection"
          :onSelect="handleSelect"
          :realTimeData="realTimeData"
          style="margin: 10px 0px;"
        ></Dropdown>
     <!-- 对数线性显示切换 -->
    <!-- <el-row>
      <el-col>
         <el-button @click="handelLineSwitch"
         style="margin-left:100px;height:35px;border-radius:6px;"
         >{{ $t(`home.switch`)
          }}<span class="according"> {{ $t(switch3) }}</span></el-button
        >
      </el-col>
    </el-row> -->



    <el-row>
      <el-col :span="24">      
        <div
          id="profitRateBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>



  </div>
</template>

<script>
import IndexJs from "../profitrate/index"
export default {
  mixins:[IndexJs]
}
</script>


<style lang="scss" scoped>
.formula{
  width: 98.7%;
    padding: 10px 0px;
    margin-bottom: -30px;
    // height: 60px;
    background: #e5e5e5;
    color: rgba(0, 0, 0, 0.6);

    p{
      padding: 0px 10px;
      // font-weight: 600;
      span{
        font-weight: 500;
        font-size: 12px;
      }
      
    }
}

  .formulaBox1{
    // outline: 1px solid red;
    display: flex;
    padding: 0px 10px;
    align-items: center;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 600;
    
    div{
      // outline: 1px solid red;
      color: rgba(0, 0, 0, 0.6);
    }
    div:nth-of-type(1){
      font-size: 16px;
      // font-weight: 600;
      span{
        font-size: 12px;
        font-weight: normal;
        // outline: 1px solid red;
      

      }
    }
    div:nth-of-type(2){
      display: flex;
      flex-direction: column;
      margin-left: 5px;
      p{
        margin: 0px;
        // outline: 1px solid red;
      }
      p:nth-of-type(1){
        border-bottom: 1px solid rgba(0, 0, 0, 0.6);
      }

      // p:nth-of-type(2){
      //   padding-left: 90px;
      // }
      span{
        font-size: 16px;
      }
    
    }
  }
</style>